var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"animation":"rotation 5s infinite linear"}},[_c('Animation',{ref:"anim",attrs:{"animation-data":_vm.animationLoopData,"auto-play":"","loop":"","speed":_vm.speed},on:{"loopComplete":_vm.onComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }